import React, { Component } from 'react';
import Select from 'react-select';
import Firebase from 'firebase';

export default class MultiSelectFieldForms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            value: this.props.forms,
            options: {},
            stores_users: []

        }
        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentWillMount() {
        var formRef = Firebase.database().ref('forms');
        formRef
            .orderByChild('client_id')
            .equalTo(localStorage.client_id)
            .once('value')
            .then(resp => {
                this.setOptions(resp.val());
            });
    }

    setOptions(forms) {
        var options = [];
        Object.keys(forms).map((m, index) => {
            var value = {
                label: Object.values(forms)[index].name,
                value: Object.keys(forms)[index]
            }
            options.push(value);
        });
        this.setState({ options: options });
    }

    handleSelectChange(value) {
        this.setState({ value });
        var array = value.split(',');
        this.props.callBack(array);
    }

    render() {
        return (
            <div className="section">
                <Select multi simpleValue value={this.state.value} placeholder="Seleccione formularios asignados" options={Object.values(this.state.options)} onChange={this.handleSelectChange} />
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/views/users/MultiSelectFieldForms.js